import { Injectable, InjectionToken } from '@angular/core';

export const QOME_PUBLIC_API_CONFIGURATION = new InjectionToken<QomePublicApiConfiguration>('qome-public-api-configuration');

@Injectable()
export class QomePublicApiConfiguration {
    public basePath?: string;
    constructor() {}
}